import { BottomSheetOptions } from 'types/bottomsheet';

import Coin777PromotionContent from 'components/bottomsheet/coin/Coin777Promotion';
import CoinAllPromotion from 'components/bottomsheet/coin/CoinAllPromotion';
import CoinSinglePromotion from 'components/bottomsheet/coin/CoinSinglePromotion';
import WeeklyPassOffer from 'components/bottomsheet/coin/WeeklyPassOffer';
import CommonContent from 'components/bottomsheet/CommonContent';
import EditPreferRelationShip from 'components/bottomsheet/profile/EditPreferRelationShip';
import Profile from 'components/bottomsheet/profile/Profile';
import TimeBuffDiscount from 'components/bottomsheet/timebuff/TimeBuffDiscount';
import TimeBuffFilters from 'components/bottomsheet/timebuff/TimeBuffFilter';
import TimeBuffHistory from 'components/bottomsheet/timebuff/TimeBuffHistory';
import TimeBuffPromotion from 'components/bottomsheet/timebuff/TimeBuffPromotion';
import TimeBuffPurchase from 'components/bottomsheet/timebuff/TimeBuffPurchase';
import TimeBuffPurchaseComplete from 'components/bottomsheet/timebuff/TimeBuffPurchaseComplete';
import DeleteMessage from 'components/bottomsheet/chat/DeleteMessage';
import PictureUpload from 'components/bottomsheet/chat/PictureUpload';
import ThemeSetting from 'components/bottomsheet/settings/ThemeSetting';
import AlertPermissionSheet from 'components/bottomsheet/event/AlertPermissionSheet';
import AlertCanSwipe from 'components/bottomsheet/event/AlertCanSwipe';
import SmartStoreOrder from 'components/bottomsheet/shop/SmartStoreOrder';
import LocalPriceSheet from 'components/bottomsheet/shop/LocalPriceSheet';
import PrimeSwipeCall from './prime/PrimeSwipeCall';
import PrimeSwipeCallEnd from './prime/PrimeSwipeCallEnd';
import PrimeGemCostConfirm from './prime/PrimeGemCostConfirm';
import NeedCoinContent from './coin/NeedCoin';
import PwaInstallGuide from 'components/bottomsheet/event/PwaInstallGuide';
import LoginMethod from 'components/bottomsheet/login/LoginMethod';

const BOTTOM_SHEETS: Record<string, { content: React.ComponentType; options?: BottomSheetOptions }> = {
  Coin777: { content: Coin777PromotionContent, options: { fullScreen: true, background: '#121212', draggable: false, confirmCancel: { confirm: true } } },
  CoinAllPromotion: { content: CoinAllPromotion, options: { fullScreen: true, background: '#121212', draggable: false, confirmCancel: { confirm: true } } },
  CoinSinglePromotion: { content: CoinSinglePromotion, options: { fullScreen: true, background: '#121212', draggable: false, confirmCancel: { confirm: true } } },
  WeeklyPass: { content: WeeklyPassOffer, options: { fullScreen: true, background: '#121212', draggable: false, confirmCancel: { confirm: true } } },
  NeedCoin: { content: NeedCoinContent },
  TimeBuffPromotion: {
    content: TimeBuffPromotion,
    options: { fullScreen: true, background: 'linear-gradient(180deg, #121212 40%, #FFABCE 100%)', draggable: false, confirmCancel: { confirm: true } },
  },
  TimeBuffFilter: { content: TimeBuffFilters, options: { background: 'linear-gradient(116deg, #FFADCF 1.5%, #FF4390 50.75%, #FF4390 100%)' } },
  TimeBuffHistory: { content: TimeBuffHistory },
  TimeBuffPurchase: { content: TimeBuffPurchase, options: { background: 'rgba(255, 67, 144, 0.50)', blur: true } },
  TimeBuffPurchaseComplete: { content: TimeBuffPurchaseComplete, options: { fullScreen: true, background: 'rgba(0, 0, 0, 0.85)', draggable: false } },
  TimeBuffDiscount: {
    content: TimeBuffDiscount,
    options: { fullScreen: true, background: 'linear-gradient(180deg, #000 19.5%, #FF9AC4 100%)', draggable: false, confirmCancel: { confirm: true } },
  },
  Common: { content: CommonContent },
  Profile: { content: Profile, options: { showScrollBar: true } },
  EditPreferRelationShip: { content: EditPreferRelationShip },
  DeleteMessage: { content: DeleteMessage },
  PictureUpload: { content: PictureUpload },
  ThemeSetting: { content: ThemeSetting },
  AlertPermissionSheet: { content: AlertPermissionSheet },
  AlertCanSwipe: { content: AlertCanSwipe },
  SmartStoreOrder: { content: SmartStoreOrder },
  LocalPriceSheet: { content: LocalPriceSheet },
  PrimeSwipeCall: { content: PrimeSwipeCall },
  PrimeSwipeCallEnd: { content: PrimeSwipeCallEnd },
  PrimeGemCostConfirm: { content: PrimeGemCostConfirm },
  PwaInstallGuide: { content: PwaInstallGuide },
  // 로그인 화면(#hLoginPage, z-index 110) 위에 뜬다
  LoginMethod: { content: LoginMethod, options: { background: 'black', zIndex: 120 } },
};

export default BOTTOM_SHEETS;
